/* eslint-disable */

window.__APPS__ = window.__APPS__ || {};
window.__APPS__.trace = {
  version: process.env.APP_VERSION
};
